var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yn-toggle",class:{'disabled': _vm.isDisabled, 'read-only': _vm.isReadOnly, 'used-in-play': _vm.usedInPlay},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.value ? "Yes" : "No"))])}
var staticRenderFns = []

export { render, staticRenderFns }